import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import React from "react";
import {match, radius, type} from "common/tokens";

const useStyles = makeStyles({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    alignSelf: 'flex-start',
    borderRadius: radius.PILL,
    padding: '4px 8px',
    ...type.chipSmall,
  },
  neutral: {
    background: match.BADGE_NEUTRAL_BG,
    color: match.BADGE_NEUTRAL_FG,
  },
  danger: {
    background: match.BADGE_DANGER_BG,
    color: match.BADGE_DANGER_FG,
  },
  success: {
    background: match.BADGE_SUCCESS_BG,
    color: match.BADGE_SUCCESS_FG,
  },
});

const StatusBadge = ({label, tone = 'neutral', icon: Icon, className}) => {
  const classes = useStyles();

  return (
    <span className={classNames(classes.badge, classes[tone] || classes.neutral, className)}>
      {Icon && <Icon size={11} strokeWidth={2.75}/>}
      {label}
    </span>
  );
};

export default StatusBadge;
